import React, { useState, useEffect } from 'react';

export default function TextMessageModal({ open, onClose, node, onSave }) {
  const [formData, setFormData] = useState({
    message: '',
    delay: 0
  });

  useEffect(() => {
    if (open && node) {
      setFormData({
        message: node.data.message || '',
        delay: node.data.delay || 0
      });
    }
  }, [open, node]);

  const handleSave = () => {
    if (onSave) {
      onSave(node.id, formData);
    }
    onClose();
  };

  const handleCancel = () => {
    // Reset form data to original values when canceling
    if (node) {
      setFormData({
        message: node.data.message || '',
        delay: node.data.delay || 0
      });
    }
    onClose();
  };

  // Button functionality removed - text messages only

  if (!open) return null;

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  };

  const contentStyle = {
    background: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
    minWidth: '600px',
    maxWidth: '700px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
  };

  const inputStyle = {
    width: '100%',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '12px',
    fontSize: '14px',
    marginBottom: '16px',
    outline: 'none',
    resize: 'vertical',
    minHeight: '120px'
  };

  const buttonStyle = {
    background: '#007bff',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    marginRight: '8px',
    transition: 'all 0.2s ease'
  };

  const secondaryButtonStyle = {
    background: '#6c757d',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer'
  };

  const dynamicButtonStyle = {
    background: '#e3f2fd',
    color: '#1976d2',
    border: '1px solid #bbdefb',
    borderRadius: '4px',
    padding: '6px 12px',
    fontSize: '13px',
    cursor: 'pointer',
    marginRight: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  };

  return (
    <div style={modalStyle} onClick={handleCancel}>
      <div style={contentStyle} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: '#495057', fontSize: '20px', fontWeight: '600' }}>
            Configure Text Message
          </h2>
          <p style={{ margin: '8px 0 0 0', color: '#6c757d', fontSize: '14px' }}>
            Please provide your reply message
          </p>
        </div>

        {/* Dynamic Content Options */}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
          <button style={dynamicButtonStyle}>
            <span>⚙️</span>
            Custom
            <span>▼</span>
          </button>
          <button style={dynamicButtonStyle}>
            <span>👤</span>
            Name
          </button>
        </div>

        {/* Message Input Area */}
        <div style={{ position: 'relative', marginBottom: '16px' }}>
          <textarea
            value={formData.message}
            onChange={e => setFormData(prev => ({ ...prev, message: e.target.value }))}
            placeholder="WhatsApp text message limit is 4096 characters."
            style={inputStyle}
            maxLength={4096}
          />
          <div style={{ position: 'absolute', top: '8px', right: '8px', fontSize: '16px', cursor: 'pointer' }}>
            😊
          </div>
          <div style={{ position: 'absolute', bottom: '8px', right: '8px', fontSize: '16px', cursor: 'pointer' }}>
            🟢
          </div>
        </div>

        {/* Delay Setting */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Delay in reply
          </label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <input
              type="range"
              min="0"
              max="30"
              value={formData.delay}
              onChange={e => setFormData(prev => ({ ...prev, delay: parseInt(e.target.value) }))}
              style={{ flex: 1 }}
            />
            <span style={{ fontSize: '14px', color: '#6c757d', minWidth: '50px' }}>
              {formData.delay} sec
            </span>
          </div>
        </div>

        {/* Buttons section removed - text messages only */}

        {/* Separator */}
        <div style={{ 
          borderTop: '2px dashed #dee2e6', 
          margin: '20px 0',
          height: '1px'
        }} />

        {/* Action Buttons */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button
            onClick={handleSave}
            style={{ ...buttonStyle, display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            💾 Save
          </button>
          <button
            onClick={handleCancel}
            style={{ ...secondaryButtonStyle, display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            ✕ Cancel
          </button>
        </div>
      </div>
    </div>
  );
} 